<template>
  <div class="d-block px-2 py-3">
    <modalConfirm
      ref="modalConfirm"
      confirm-text="Yakin"
      @action="confirmPayment"
      confirmColor="primary"
    >
      <template v-slot:title>
        <span class="primary--text text-capitalize font-weight-bold"
          >Konfirmasi</span
        >
      </template>
      <template v-slot:body>
        <div class="text-center">
          Apakah Anda yakin untuk melakukan konfirmasi pembayaran?
        </div>
      </template>
    </modalConfirm>
    <modalPayment ref="modalPayment" @action="confirmTransfer"></modalPayment>
    <modalConfirm
      ref="modalCancel"
      confirm-text="Yakin"
      @action="cancelTransactionV2"
      confirmColor="error"
    >
      <template v-slot:title>
        <span class="primary--text text-capitalize font-weight-bold"
          >Konfirmasi</span
        >
      </template>
      <template v-slot:body>
        <div class="text-center">
          Apakah Anda yakin untuk melakukan pembatalan transaksi?
        </div>
      </template>
    </modalConfirm>
    <v-card outlined elevation="0" id="filter-card" class="my-5">
      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" sm="3" class="py-0" :class="{ 'mb-2': isMobile }">
              <v-menu
                ref="menuDate"
                v-model="menuDate"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeText"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details="auto"
                    outlined
                    clearable
                    densed
                    class="datePickerSmall"
                    placeholder="Tanggal"
                    @click:clear="clearDate"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filter.dateRange"
                  no-title
                  @click:date="searchTrx"
                  @change="tglTransaksiFilter.value = filter.dateRange"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="3" class="py-0" :class="{ 'mb-2': isMobile }">
              <v-combobox
                v-model="filter.type"
                dense
                outlined
                item-text="label"
                item-value="value"
                hide-details="auto"
                :items="filterOptions"
              ></v-combobox>
            </v-col>

            <v-col cols="12" sm="6" class="py-0" :class="{ 'mb-2': isMobile }">
              <v-text-field
                v-model="filter.search"
                outlined
                small
                dense
                clearable
                hide-details="auto"
                class="searchInput"
                @input="
                  (buyerNameFilter.value = filter.search),
                    (invoiceNoFilter.value = filter.search),
                    (invoiceTrxFilter.value = filter.search)
                "
                @click:clear="clearSearch"
                @keyup.enter="searchTrx"
                placeholder="Masukkan kata kunci"
              >
                <div slot="append">
                  <v-btn small elevation="2" color="success" @click="searchTrx">
                    <v-icon center>mdi-magnify</v-icon>
                  </v-btn>
                </div>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" sm="3" class="py-0">
              <v-menu bottom offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateTempoText"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details="auto"
                    outlined
                    clearable
                    densed
                    class="datePickerSmall"
                    placeholder="Tanggal Riwayat Nego"
                    @click:clear="clearDate"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filter.dateRangeTempo"
                  range
                  @blur="searchTrx"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
              <v-col cols="12" class="text-right pb-0 pt-5 mt-3">
                <v-btn :loading="exportLoading" outlined elevation="2" dark class="mr-3 mb-md-0 mb-3"  @click="exportExcel">
                  <v-icon center class="mr-2">mdi-download</v-icon>Laporan
                </v-btn>
                <v-btn color="success" elevation="2" dark class="mr-3" width="140" @click="searchTrx">
                  <strong class="text-uppercase">Cari</strong>
                </v-btn>
              </v-col>
            </v-row>
          <!-- <v-row class="mt-3 d-none">
            <v-col cols="6" class="py-0"></v-col>

            <v-col cols="3" class="py-0">
              <v-select
                v-model="filter.filterId"
                :items="categories"
                item-text="nama"
                placeholder="Pilih Filter"
                outlined
                multiple
                dense
                hide-details="auto"
              ></v-select>
            </v-col>

            <v-col cols="3" class="py-0">
              <v-select
                v-model="filter.sortId"
                :items="categories"
                item-text="nama"
                placeholder="Pilih Sorting"
                outlined
                multiple
                dense
                hide-details="auto"
              ></v-select>
            </v-col>
          </v-row>-->
        </v-form>
      </v-card-text>
    </v-card>
    <div v-if="!loadingList" class="d-flex flex-wrap">
      <v-chip class="mr-2 mb-2" color="primary" outlined>
        <v-icon left>mdi-information-outline</v-icon>
        Jumlah Pesanan : {{ pesananPagination.total_data }}
      </v-chip>
      <v-chip class="mr-2 mb-2" color="primary" outlined>
        <v-icon left>mdi-information-outline</v-icon>
        Summary Sisa Tagihan : {{ summaryTempo |toRupiah}}
      </v-chip>
    </div> 
    <v-layout v-resize="onResize" column>
      <v-data-table
        v-model="selected"
        :server-items-length="pesananPagination.total_data"
        :items="listPesanan"
        :loading="loadingList"
        :headers="headers"
        :expanded.sync="expanded"
        :hide-default-header="true"
        :hide-default-footer="true"
        mobile-breakpoint="600"
        item-key="trx_id"
        show-expand
        single-expand
        class="elevation-1 border"
        :class="{ mobile: isMobile }"
        id="order-table"
        @item-expanded="loadDetailPesanan"
      >
        <template v-slot:item.trx_code="{ item }">
          <v-row
            class="d-flex align-start pa-3"
            :class="isMobile ? 'flex-column' : 'flex-row'"
          >
            <v-col
              cols="12"
              sm="3"
              class="d-flex flex-column align-start justify-start"
              :class="{ 'mb-3 pa-0': isMobile }"
            >
              <router-link
                :to="'/seller/pesanan-saya'"
                class="font-weight-bold no-line"
                >{{ item.trx_code }}</router-link
              >
              <v-chip
                small
                label
                class="mt-2 font-weight-bold"
                :class="colorStatus(item.payment_status)"
                >{{ statusCaption(item.payment_status) }}</v-chip
              >
              <!-- xx
              {{item}}-->
              <template v-if="item.order_id_kiriminaja">
                <v-chip
                  small
                  label
                  class="mt-2 font-weight-bold"
                  v-if="item.is_drop == '1'"
                  >Drop Off</v-chip
                >
                <v-chip small label class="mt-2 font-weight-bold" v-else
                  >Pickup</v-chip
                >
              </template>
              <!-- <v-chip
                small
                label
                class="mt-2 font-weight-bold"
                v-if="item.delivery_status=='1' && item.trx_status!='completed'"
              >Diterima: {{item.delivery_receiver}}</v-chip> -->
            </v-col>
            <v-col
              cols="12"
              sm="2"
              class="text-subtitle-2 black-text font-weight-bold"
              :class="isMobile ? 'mb-3 mx-0 pa-0' : 'mx-5 px-0'"
            >
              {{ item.trx_buyer_user_name }}
              <span class="d-block text-caption">{{
                item.trx_buyer_user_mobilephone
              }}</span>
            </v-col>
            <v-col
              cols="12"
              sm="3"
              class="text-caption d-flex flex-column align-start"
              :class="{ 'mb-3 pa-0': isMobile }"
            >
              <div class="d-flex flex-column justify-start text-left">
                <strong>Tanggal Pemesanan</strong>
                <span class="pl-0">{{
                  formatDateText(
                    item.trx_status_created_datetime,
                    "DD MMM YYYY HH:mm"
                  )
                }}</span>
              </div>
              <div
                class="flex-row"
                v-if="item.is_top == '1'"
              >
                <strong>Jatuh tempo</strong>
                <div class="red--text font-weight-bold">
                  {{ item.termin_date | tanggal }}
                </div>
              </div>
              <div class="flex-row" v-if="item.trx_status == 'paid'">
                <strong>Batas proses pesanan</strong>
                <div class="pl-2 red--text font-weight-bold">
                  {{ item.trx_limit_confirmation_paid | haritanggaljam }}
                  <!-- <daycount :date="item.trx_midtrans_expired_datetime"></daycount> -->
                </div>
              </div>
              <div class="flex-row" v-if="item.trx_status == 'processed'">
                <strong>Batas kirim pesanan</strong>
                <div class="pl-2 red--text font-weight-bold">
                  {{ item.trx_limit_confirmation_processed | haritanggaljam }}
                  <!-- <daycount :date="item.trx_midtrans_expired_datetime"></daycount> -->
                </div>
              </div>
              <div
                class="flex-row"
                v-if="
                  (item.trx_status == 'on_delivery' ||
                    item.trx_status == 'delivery') &&
                  item.delivery_status == '1'
                "
              >
                <strong>Batas Respon Pembeli</strong>
                <div class="pl-2 green--text font-weight-bold">
                  {{ item.trx_limit_confirmation_delivery | haritanggaljam }}
                  <!-- <daycount :date="item.trx_midtrans_expired_datetime"></daycount> -->
                </div>
              </div>
              <div class="d-none">
                <strong>Alasan Pembatalan</strong>
                <span class="pl-2 red--text font-weight-bold"
                  >Stok di Gudang Rusak</span
                >
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="3"
              class="text-caption d-flex flex-column align-start"
              :class="{ 'mb-3 pa-0': isMobile }"
            >
              <div class="d-flex flex-column justify-start text-left">
                <strong>Tagihan Dibayarkan</strong>
                <span class="pl-0 green--text font-weight-bold">{{
                  item.payment_finance_amount |toRupiah
                }}</span>
              </div>
              <div class="d-flex flex-column justify-start text-left">
                <strong>Tagihan Sisa</strong>
                <span class="pl-0 red--text font-weight-bold">{{
                  item.payment_remaining_debt |toRupiah
                }}</span>
              </div>

            </v-col>
          </v-row>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="mb-2" v-if="!loadingDetail">
            <v-row class="mb-1">
              <v-col
                cols="12"
                sm="5"
                class="text-left"
                :class="{ 'pb-0': isMobile }"
              >
                <template v-for="(produk, idp) in detailPesanan.trx_detail">
                  <div
                    class="d-flex flex-row align-start"
                    :class="isMobile ? 'mb-0' : 'mb-4'"
                    :key="idp"
                  >
                    <v-img
                      width="80"
                      max-width="80"
                      class="mr-4"
                      :src="
                        produk.trx_detail_product_image[0]
                          ? produk.trx_detail_product_image[0]
                          : '/assets/product/default.png'
                      "
                    ></v-img>
                    <div class="d-flex flex-column align-start">
                      <div class="font-weight-bold no-line green--text">
                        {{ produk.trx_detail_product_name }}
                      </div>
                      <div class="text-caption">
                        {{ produk.trx_detail_quantity }} barang ({{
                          produk.trx_detail_product_weight | toKg
                        }}) @ {{ produk.trx_detail_product_price | toRupiah }}
                      </div>
                      <div class="text-caption">
                        Subtotal :
                        <strong>{{
                          (produk.trx_detail_product_price *
                            produk.trx_detail_quantity)
                            | toRupiah
                        }}</strong>
                      </div>
                      <div
                        v-if="produk.trx_detail_is_nego == '1'"
                        class="text-caption"
                      >
                        Harga Nego :
                        <strong>{{
                          produk.trx_detail_price_nego | toRupiah
                        }}</strong>
                      </div>
                    </div>
                  </div>
                </template>
              </v-col>

              <v-col
                cols="12"
                sm="3"
                class="text-left"
                :class="{ 'pl-0': !isMobile }"
                       v-if="['courier','store_courier'].includes(detailPesanan.trx_shipping_method)  "
              >
                <div class="d-flex flex-column align-start">
                  <div
                    class="text-subtitle-2 font-weight-bold black--text mb-1"
                  >
                    Alamat
                  </div>
                  <span
                    class="text-caption"
                    v-if="detailPesanan.trx_agregator == 'kiriminaja'"
                    >{{ detailPesanan.destination_name }}</span
                  >
                  <span class="text-caption" v-else>{{
                    detailPesanan.user_address_name
                  }}</span>
                  <span class="text-caption">{{
                    detailPesanan.user_address_detail
                  }}</span>
                  <span class="text-caption"
                    >{{ detailPesanan.user_address_subdistrict_name }},
                    {{ detailPesanan.user_address_city_name }},
                    {{ detailPesanan.user_address_province_name }}
                    {{ detailPesanan.user_address_zipcode }}</span
                  >
                </div>
              </v-col>

              <v-col
                cols="12"
                sm="5"
                class="text-left"
                :class="{ 'pl-0': !isMobile }"
                v-else
              >
                <div class="d-flex flex-column align-start">
                  <div
                    class="text-subtitle-2 font-weight-bold black--text mb-1"
                  >
                    Opsi Pengambilan
                  </div>
                  <span class="text-caption">Ambil di Toko</span>
                  <div
                    class="text-subtitle-2 font-weight-bold black--text mb-1"
                  >
                    Tanggal Pengambilan
                  </div>
                  <span class="text-caption">{{
                    detailPesanan.trx_pick_up_date | tanggal
                  }}</span>
                </div>
              </v-col>

              <v-col
                cols="12"
                sm="2"
                class="text-left"
                        v-if="['courier','store_courier'].includes(detailPesanan.trx_shipping_method)  "
              >
              <div class="d-flex flex-column align-start">
                  <div class="text-subtitle-2 font-weight-bold black--text mb-1">{{ detailPesanan.trx_shipping_method == 'courier' ? 'Kurir' : 'Pengiriman'}}</div>
                  <span 
                    class="text-caption"
                  ><template  v-if="['courier'].includes(detailPesanan.trx_shipping_method)  ">{{ (detailPesanan.trx_courier_code) ? detailPesanan.trx_courier_code.toUpperCase() : '' }}</template> {{ detailPesanan.trx_courier_service }}</span>
                  <span v-if="['courier'].includes(detailPesanan.trx_shipping_method)  " class="text-caption">({{ detailPesanan.trx_courier_etd }})</span>
                  <span 
                    class="text-caption font-weight-bold"
                  >{{ detailPesanan.trx_price_shipping | toRupiah }}</span>
                </div>
              </v-col>

              <v-col cols="12" sm="2" class="text-left pr-0">
                <div class="d-flex flex-column align-start">
                  <div
                    class="text-subtitle-2 font-weight-bold black--text mb-1"
                  >
                    Total Belanja
                  </div>
                  <span class="text-subtitle-1 font-weight-bold green--text">{{
                    detailPesanan.trx_bill | toRupiah
                  }}</span>
                </div>
              </v-col>
            </v-row>

            <hr />
            <v-row>
              <v-col
                cols="12"
                sm="12"
                class="text-left"
                :class="isMobile ? 'order-2 pt-2' : 'pt-5'"
              >
                <template
                  v-if="
                    detailPesanan.is_top == '1' &&
                    ['0', '2'].includes(detailPesanan.trx_status_nego)
                  "
                >
                  <v-btn
                    outlined
                    dark
                    color="grey"
                    :class="{ 'v-btn--block': isMobile }"
                    class="ml-2"
                    @click="uploadPayment"
                  >
                    <v-icon v-if="!isMobile">mdi-upload</v-icon>
                    <span
                      class="text-subtitle-2 text-capitalize font-weight-bold"
                      :class="{ 'ml-2': !isMobile }"
                      >Upload Bukti Bayar</span
                    >
                  </v-btn>
                  <v-btn
                    outlined
                    dark
                    color="orange"
                    :class="{ 'v-btn--block': isMobile }"
                    class="ml-2"
                    target="_blank"
                    :to="
                      '/seller/verifikasi-pembayaran?code=' +
                      detailPesanan.trx_code
                    "
                  >
                    <v-icon v-if="!isMobile">mdi-clipboard-check</v-icon>
                    <span
                      class="text-subtitle-2 text-capitalize font-weight-bold"
                      :class="{ 'ml-2': !isMobile }"
                      >Riwayat Pembayaran</span
                    >
                  </v-btn>
                  <v-btn
                    outlined
                    dark
                    v-if="detailPesanan.trx_is_nego == '1'"
                    color="#2196F3"
                    :class="{ 'v-btn--block': isMobile }"
                    class="ml-2"
                    target="_blank"
                    :to="
                      '/seller/riwayat-nego-produk?code=' +
                      detailPesanan.trx_code
                    "
                  >
                    <v-icon v-if="!isMobile">mdi-clipboard-check</v-icon>
                    <span
                      class="text-subtitle-2 text-capitalize font-weight-bold"
                      :class="{ 'ml-2': !isMobile }"
                      >Riwayat Nego Produk</span
                    >
                  </v-btn>
                </template>
              </v-col>
            </v-row>
          </td>

          <td :colspan="headers.length" v-else>
            <div class="d-block text-center pa-4 text-caption">loading...</div>
          </td>
        </template>

        <template v-slot:no-data>
          <div class="d-flex flex-column align-center py-5 px-5">
            <v-img
              width="150"
              height="150"
              max-width="150"
              class="py-5 my-4"
              src="/assets/seller/belum-ada-pesanan.svg"
            ></v-img>
            <div class="text-subtitle-1 black--text font-weight-bold">
              Tidak ada data transaksi yang dapat ditampilkan.
            </div>
          </div>
        </template>
      </v-data-table>
    </v-layout>

    <v-pagination
      v-if="pesananPagination.total_page > 1 && listPesanan.length > 0"
      @input="updatePage"
      v-model="page"
      :length="pesananPagination.total_page"
      total-visible="7"
      circle
      class="d-flex justify-end no-button-focus py-2"
    ></v-pagination>

    <v-dialog v-model="lacakStatusPesanan" persistent max-width="600">
      <v-card>
        <v-card-title
          class="text-h6 text-h6 text-capitalize black--text darken-4"
        >
          <v-img
            width="25"
            max-width="25"
            class="mr-2"
            src="/assets/seller/status-pesanan-no-padding.svg"
          ></v-img
          >Lacak Pesanan
        </v-card-title>
        <v-card-text class="py-0 px-5">
          <!-- {{historyTrackingData}} -->
          <template v-if="detailPesanan">
            <v-row class="px-5 py-3 align-center">
              <v-col cols="12" sm="6">
                <div
                  class="d-block text-subtitle-1 font-weight-bold black--text"
                >
                  {{ detailPesanan.trx_code }}
                </div>
                <div class="text-subtitle-2">
                  {{
                    formatDateText(
                      detailPesanan.trx_status_created_datetime,
                      "DD MMMM YYYY HH:mm"
                    )
                  }}
                </div>
                <div class="text-subtitle-2">
                  Kurir: {{ detailPesanan.trx_courier_code }}
                </div>
                <div class="text-subtitle-2">
                  Resi: {{ detailPesanan.trx_courier_resi }}
                </div>
              </v-col>

              <v-col
                cols="12"
                sm="6"
                :class="isMobile ? 'text-left pt-0' : 'text-right'"
              >
                <v-chip
                  v-if="detailPesanan.trx_status == 'completed'"
                  label
                  class="font-weight-bold"
                  :class="colorStatus(detailPesanan.trx_status)"
                  >{{ statusCaption(detailPesanan.trx_status) }}
                </v-chip>
                <v-chip
                  v-else-if="detailPesanan.delivery_status == '1'"
                  label
                  class="font-weight-bold"
                  :class="colorStatus('completed')"
                  >Telah Diterima</v-chip
                >
                <template v-else-if="historyTrackingData.length">
                  <v-chip
                    label
                    class="font-weight-bold"
                    :class="colorStatus('on_delivery')"
                    v-if="
                      detailPesanan.trx_status == 'pickup' &&
                      detailPesanan.is_drop == '0'
                    "
                    >{{ "Menunggu Pickup" }}
                  </v-chip>
                  <v-chip
                    label
                    class="font-weight-bold"
                    :class="colorStatus('on_delivery')"
                    v-else-if="
                      detailPesanan.trx_status == 'pickup' &&
                      detailPesanan.is_drop == '1'
                    "
                    >{{ "Menunggu Diantar" }}
                  </v-chip>
                  <v-chip
                    label
                    class="font-weight-bold"
                    :class="colorStatus('on_delivery')"
                    v-else
                    >{{ statusCaption(detailPesanan.trx_status) }}
                  </v-chip>
                </template>

                <v-chip
                  v-else
                  label
                  class="font-weight-bold"
                  :class="colorStatus(detailPesanan.trx_status)"
                  >{{ statusCaption(detailPesanan.trx_status) }}</v-chip
                >
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
            <hr />

            <div class="d-block py-5">
              <v-timeline align-top dense v-if="historyTrackingData.length">
                <template v-for="(log, idl) in historyTrackingData">
                  <v-timeline-item
                    :color="idl == 0 ? 'green' : 'grey darken-5'"
                    small
                    :key="idl"
                    v-if="log.manifest_datetime"
                  >
                    <v-row class="py-0">
                      <v-col cols="12" sm="4" class="py-0">
                        <span class="grey--text">{{
                          formatDateText(
                            log.manifest_datetime,
                            "DD MMMM YYYY HH:mm"
                          )
                        }}</span>
                      </v-col>
                      <v-col class="py-0">
                        <div
                          class="d-block font-weight-bold black--text"
                          :class="{ 'text-subtitle-2': isMobile }"
                        >
                          {{ log.manifest_description }}
                          <br />
                          <span class="grey--text">{{ log.city_name }}</span>
                          <template
                            v-if="
                              detailPesanan.delivery_status == '1' && idl == 0
                            "
                          >
                            <br />
                            <span class="grey--text"
                              >DELIVERY :
                              {{ detailPesanan.delivery_receiver }}</span
                            >
                          </template>
                        </div>
                      </v-col>
                    </v-row>
                  </v-timeline-item>
                </template>
              </v-timeline>
              <div v-else>
                <center>
                  Sistem belum menerima data dari Ekspedisi, mohon ulangi
                  beberapa saat lagi.
                </center>
              </div>
            </div>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr />
            <v-btn
              outlined
              @click="(lacakStatusPesanan = false), (selectedItem = null)"
              class="my-2 px-5 text-capitalize"
              >Tutup</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogStatusPesanan" persistent max-width="600">
      <v-card>
        <v-card-title
          class="text-h6 text-h6 text-capitalize black--text darken-4"
        >
          <v-img
            width="25"
            max-width="25"
            class="mr-2"
            src="/assets/seller/status-pesanan-no-padding.svg"
          ></v-img
          >Status Pesanan
        </v-card-title>
        <v-card-text class="py-0 px-5">
          <template v-if="detailPesanan">
            <v-row class="px-5 py-3 align-center">
              <v-col cols="12" sm="6">
                <div
                  class="d-block text-subtitle-1 font-weight-bold black--text"
                >
                  {{ detailPesanan.trx_code }}
                </div>
                <div class="text-subtitle-2">
                  {{
                    formatDateText(
                      detailPesanan.trx_status_created_datetime,
                      "DD MMMM YYYY HH:mm"
                    )
                  }}
                </div>
              </v-col>

              <v-col
                cols="12"
                sm="6"
                :class="isMobile ? 'text-left pt-0' : 'text-right'"
              >
                <v-chip
                  label
                  class="font-weight-bold"
                  :class="colorStatus(detailPesanan.trx_status)"
                  >{{ statusCaption(detailPesanan.trx_status) }}</v-chip
                >
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
            <hr />

            <div class="d-block py-5">
              <v-timeline align-top dense v-if="historyStatus">
                <template v-for="(log, idl) in historyStatus">
                  <v-timeline-item
                    :color="
                      log.trx_status === detailPesanan.trx_status
                        ? 'green'
                        : 'grey darken-5'
                    "
                    small
                    :key="idl"
                    v-if="log.trx_status_datetime"
                  >
                    <v-row class="py-0">
                      <v-col cols="12" sm="4" class="py-0">
                        <span class="grey--text">{{
                          formatDateText(
                            log.trx_status_datetime,
                            "DD MMMM YYYY HH:mm"
                          )
                        }}</span>
                      </v-col>
                      <v-col class="py-0">
                        <div
                          class="d-block font-weight-bold black--text"
                          :class="{ 'text-subtitle-2': isMobile }"
                        >
                          {{ log.trx_status_desc }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-timeline-item>
                </template>
              </v-timeline>
            </div>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr />
            <v-btn
              outlined
              @click="(dialogStatusPesanan = false), (selectedItem = null)"
              class="my-2 px-5 text-capitalize"
              >Tutup</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogLacak" persistent max-width="600">
      <v-card>
        <v-card-title
          class="text-h6 text-h6 text-capitalize black--text darken-4"
          >Lacak Pengiriman</v-card-title
        >
        <v-card-text class="py-0 px-5">
          <v-row class="pa-5 align-center">
            <v-col cols="3">
              <v-img class="mr-2" src="/assets/seller/kurir/jne.svg"></v-img>
            </v-col>

            <v-col cols="9">
              <div class="d-block text-subtitle-1 font-weight-bold black--text">
                INV/2020222886213302
              </div>
              <div class="text-subtitle-2">JNE (Reguler)</div>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          <hr />

          <div class="d-block py-5">
            <div
              class="d-block pa-4 mb-5 grey lighten-2 font-weight-bold black--text text-center"
            >
              Menunggu Status Resi
            </div>

            <!-- jika belum ada update -->
            <div class="d-flex flex-column align-center">
              <div class="d-block pa-2 text-center">
                <div class="text-subtitle-2">
                  Belum ada update pengiriman dari kurir. Silakan lacak kembali
                  secara berkala maksimal 3 x 24 jam.
                </div>
              </div>
            </div>

            <div class="d-flex flex-column align-center">
              <div class="d-block pa-3 text-center">
                <div
                  class="d-block text-subtitle-2 font-weight-bold black--text"
                >
                  [BANTUL] Paket telah diterima [Agung/genesis][Satpam]
                </div>
                <div class="text-subtitle-2">28 Des 2020 08:36 WIB</div>
              </div>
              <div class="v-spacer"></div>

              <div class="d-block pa-3 text-center">
                <div
                  class="d-block text-subtitle-2 font-weight-bold black--text"
                >
                  [BANTUL] Paket telah dikirim ke alamat penerima
                </div>
                <div class="text-subtitle-2">27 Des 2020 15:36 WIB</div>
              </div>
              <div class="v-spacer"></div>

              <div class="d-block pa-3 text-center">
                <div
                  class="d-block text-subtitle-2 font-weight-bold black--text"
                >
                  [YOGYAKARTA] Paket akan dikirimkan ke alamat penerima
                </div>
                <div class="text-subtitle-2">27 Des 2020 10:36 WIB</div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr />
            <v-btn
              outlined
              @click="dialogLacak = false"
              class="my-2 px-5 text-capitalize"
              >Tutup</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ModalNego
      @updateData="loadDetailPesanan"
      v-model="dialogNego"
      :data="formNego"
    />
    <v-dialog v-model="dialogSellerNotes" persistent max-width="600">
      <v-card>
        <v-card-title
          class="text-h6 text-h6 text-capitalize black--text darken-4"
          >Tambah Catatan</v-card-title
        >
        <v-card-text class="pt-3 pb-0 px-5">
          <v-textarea
            v-model="courier_note"
            outlined
            counter="200"
            maxlength="200"
            name="input-7-4"
            label="Catatan Penjual"
            @blur="detailPesanan.trx_courier_note = courier_note"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr />
            <v-btn
              outlined
              @click="dialogSellerNotes = false"
              class="my-2 px-5 text-capitalize"
              >Tutup</v-btn
            >
            <v-btn
              color="green"
              @click="dialogSellerNotes = false"
              class="my-2 px-5 ml-2 text-capitalize white--text"
              >Simpan</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCancelOrder" persistent max-width="600">
      <v-card>
        <v-card-title
          class="text-h6 text-h6 text-capitalize black--text darken-4"
          >Pembatalan Pesanan</v-card-title
        >
        <v-card-text class="pt-2 pb-0 px-5 mx-1">
          <div class="d-block font-weight-bold text-subtitle-1 black--text">
            Alasan Pembatalan :
          </div>
          <div class="cancelOption">
            <v-radio-group row>
              <v-radio v-for="n in pembatalanOpt" :key="n.id" :value="n.id">
                <template v-slot:label>
                  <v-alert
                    text
                    dense
                    outlined
                    small
                    :color="
                      n.id === pesanan[0].alasanPembatalan ? 'red' : 'grey'
                    "
                    class="mb-3"
                    >{{ n.label }}</v-alert
                  >
                </template>
              </v-radio>
            </v-radio-group>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr />
            <v-btn
              outlined
              @click="dialogCancelOrder = false"
              class="my-2 px-5 text-capitalize"
              >Tutup</v-btn
            >
            <v-btn
              color="red"
              @click="dialogCancelOrder = false"
              class="my-2 px-5 ml-2 text-capitalize white--text"
              >Batalkan</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirmTerimaorder" persistent max-width="500">
      <v-card>
        <v-card-title class="text-h6 text-h6 text-capitalize green--text">
          <span v-if="allowChangeResi == false">Konfirmasi Terima Pesanan</span>
          <span v-else>Konfirmasi Ubah Resi</span>
        </v-card-title>
        <v-card-text class="pt-2 pb-0 px-5 mx-1 text-center">
          <v-row>
            <v-col cols="12">
              <div v-if="allowChangeResi == false" class="text-subtitle-1 mb-3">
                Apakah Pesanan dengan No.
                <strong class="green--text">{{
                  selectedItem ? selectedItem.trx_code : ""
                }}</strong>
                akan diproses ?
              </div>
              <div v-else class="text-subtitle-1 mb-3">
                Apakah Anda yakin mengubah resi Pesanan dengan No.
                <strong class="green--text">{{
                  selectedItem ? selectedItem.trx_code : ""
                }}</strong
                >?
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr />
            <v-btn
              outlined
              class="my-2 px-5 text-capitalize"
              :loading="loadingStatus"
              @click="(dialogConfirmTerimaorder = false), (selectedItem = null)"
              >Tidak</v-btn
            >
            <v-btn
              v-if="allowChangeResi == false"
              color="green"
              :loading="loadingStatus"
              class="my-2 px-5 ml-2 text-capitalize white--text"
              @click="prosesPesananAct(selectedItem.trx_id)"
              >Proses</v-btn
            >
            <v-btn
              v-else
              color="green"
              :loading="loadingStatus"
              class="my-2 px-5 ml-2 text-capitalize white--text"
              @click="ubahResi(selectedItem.trx_id)"
              >Proses</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirmKirim" persistent max-width="500">
      <v-card>
        <v-card-title
          class="text-h6 text-h6 text-capitalize green--text"
          v-if="detailPesanan.trx_shipping_method == 'courier'"
          >Konfirmasi Pengiriman Pesanan</v-card-title
        >
        <v-card-title class="text-h6 text-h6 text-capitalize green--text" v-else
          >Konfirmasi Pengambilan Pesanan</v-card-title
        >
        <v-card-text class="pt-2 pb-0 px-5 mx-1 text-center">
          <v-row>
            <v-col
              cols="12"
              v-if="detailPesanan.trx_shipping_method == 'courier'"
            >
              <div class="text-subtitle-1 mb-3">
                Apakah Barang Pesanan dengan No.
                <strong class="green--text">{{
                  selectedItem ? selectedItem.trx_code : ""
                }}</strong>
                akan diproses ke pengiriman ?
              </div>
            </v-col>
            <v-col cols="12" v-else>
              <div class="text-subtitle-1 mb-3">
                Apakah Anda yakin Barang Pesanan dengan No.
                <strong class="green--text">{{
                  selectedItem ? selectedItem.trx_code : ""
                }}</strong>
                sudah diambil ?
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr />
            <v-btn
              outlined
              class="my-2 px-5 text-capitalize"
              :loading="loadingStatus"
              @click="(dialogConfirmKirim = false), (selectedItem = null)"
              >Batal</v-btn
            >
            <v-btn
              v-if="detailPesanan.trx_shipping_method == 'courier'"
              color="green"
              :loading="loadingStatus"
              class="my-2 px-5 ml-2 text-capitalize white--text"
              @click="kirimPesananAct(selectedItem.trx_id)"
              >Kirim</v-btn
            >
            <v-btn
              v-else
              color="green"
              :loading="loadingStatus"
              class="my-2 px-5 ml-2 text-capitalize white--text"
              @click="pengambilanPesananAct(selectedItem.trx_id, pickup_date)"
              >Ya</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmRequestPickup" persistent max-width="500">
      <v-card>
        <v-card-title
          class="text-h6 text-h6 text-capitalize green--text"
          v-if="detailPesanan.trx_shipping_method == 'courier'"
        >
          Konfirmasi Request
          <strong v-if="selectedItem && selectedItem.is_drop == 1"
            >&nbsp;Drop Off</strong
          >
          <strong v-else>&nbsp;Pickup</strong>
        </v-card-title>
        <v-card-title class="text-h6 text-h6 text-capitalize green--text" v-else
          >Konfirmasi Pengambilan Pesanan</v-card-title
        >
        <v-card-text class="pt-2 pb-0 px-5 mx-1 text-center">
          <v-row>
            <v-col
              cols="12"
              v-if="detailPesanan.trx_shipping_method == 'courier'"
            >
              <div class="text-subtitle-1 mb-3">
                Apakah Barang Pesanan dengan No.
                <strong class="green--text">{{
                  selectedItem ? selectedItem.trx_code : ""
                }}</strong>
                akan diproses ke Ekspedisi?
              </div>
            </v-col>
            <v-col cols="12" v-else>
              <div class="text-subtitle-1 mb-3">
                Apakah Anda yakin Barang Pesanan dengan No.
                <strong class="green--text">{{
                  selectedItem ? selectedItem.trx_code : ""
                }}</strong>
                sudah diambil ?
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr />
            <v-btn
              outlined
              class="my-2 px-5 text-capitalize"
              :loading="loadingStatus"
              @click="
                (dialogConfirmRequestPickup = false), (selectedItem = null)
              "
              >Batal</v-btn
            >
            <template v-if="detailPesanan.trx_shipping_method == 'courier'">
              <v-btn
                v-if="selectedItem && selectedItem.is_drop == 1"
                color="green"
                :loading="loadingStatus"
                class="my-2 px-5 ml-2 text-capitalize white--text"
                @click="requestPickupPesananAct(selectedItem.trx_id, 1)"
                >Drop Off</v-btn
              >
              <v-btn
                v-else
                color="green"
                :loading="loadingStatus"
                class="my-2 px-5 ml-2 text-capitalize white--text"
                @click="requestPickupPesananAct(selectedItem.trx_id)"
                >Pickup</v-btn
              >
            </template>
            <v-btn
              v-else
              color="green"
              :loading="loadingStatus"
              class="my-2 px-5 ml-2 text-capitalize white--text"
              @click="pengambilanPesananAct(selectedItem.trx_id, pickup_date)"
              >Ya</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import moment from "moment";
import modalConfirm from "@/components/ModalDelete";
import ModalNego from "./ModalNego.vue";
import ModalPayment from "../../../../store/profile/ModalPayment.vue";
export default {
  component: { moment },
  components: { modalConfirm, ModalNego, ModalPayment },
  props: ["allowedStatus", "payment"],
  data() {
    return {
      lacakStatusPesanan: false,
      exportLoading: false,
      allowChangeResi: false,
      loadingDetail: false,
      loadingStatus: false,
      loadingList: false,
      loadingTransaksi: false,
      dialogStatusPesanan: false,
      dialogSellerNotes: false,
      dialogNego: false,
      formNego: [],
      dialogLacak: false,
      dialogCancelOrder: false,
      dialogConfirmTerimaorder: false,
      dialogConfirmKirim: false,
      dialogConfirmRequestPickup: false,
      listPesanan: [],
      pickDate: false,
      pickup_date: "",
      courier_resi: "",
      courier_note: "",
      noresiRules: [(v) => !!v || "Nomor resi tidak boleh kosong"],
      noPickupdate: [(v) => !!v || "Tanggal pengambilan tidak boleh kosong"],
      panel: [0],
      menuDate: false,
      filterOptions: [
        // {
        //   label: "No. Invoice",
        //   value: "invoice",
        // },
        {
          label: "Kode Transaksi",
          value: "trx",
        },
        {
          label: "Nama Pembeli",
          value: "buyer",
        },
      ],
      filter: {
        type: {
          label: "Kode Transaksi",
          value: "trx",
        },
        search: "",
        filterId: null,
        sortId: null,
        dateRange: null,
        dateRangeTempo: [],
      },
      selected: [],
      selectedItem: {
        trx_id: "",
        is_drop: 0,
      },
      expanded: [],
      headers: [
        {
          text: "Info Pesanan",
          align: "start",
          sortable: false,
          value: "trx_code",
        },
        { text: "action", value: "data-table-expand" },
      ],
      pembatalanOpt: [
        {
          id: 0,
          label: "Stok Tidak Tersedia",
        },
        {
          id: 1,
          label: "Ekspedisi Tutup",
        },
        {
          id: 2,
          label: "Toko Sudah Tidak Aktif",
        },
        {
          id: 3,
          label: "Stok di Gudang Rusak",
        },
      ],
      page: 1,
      limit: 5,
      params: [],
      sort: {},
      sortBy: "",
      sortDir: "",
      listSort: [
        {
          sortBy: "product_price",
          sortDir: "ASC",
          sortLabel: "Harga Terendah",
        },
        {
          sortBy: "product_price",
          sortDir: "DESC",
          sortLabel: "Harga Tertinggi",
        },
        {
          sortBy: "product_input_datetime",
          sortDir: "DESC",
          sortLabel: "Produk Terbaru",
        },
        {
          sortBy: "product_sold_count",
          sortDir: "DESC",
          sortLabel: "Produk Terlaris",
        },
        {
          sortBy: "product_view_count",
          sortDir: "DESC",
          sortLabel: "Produk Terpopuler",
        },
      ],
      buyerNameFilter: {
        value: "",
        comparison: "like",
        type: "string",
        field: "trx_buyer_user_name",
      },
      invoiceNoFilter: {
        value: "",
        comparison: "like",
        type: "string",
        field: "trx_midtrans_invoice",
      },
      invoiceTrxFilter: {
        value: "",
        comparison: "like",
        type: "string",
        field: "trx.trx_code",
      },
      tglTransaksiFilter: {
        value: "",
        comparison: "like",
        type: "string",
        field: "trx_status_created_datetime",
      },
      tglTransaksiTempoFilter: {
        value: "",
        comparison: "bet",
        type: "date",
        field: "trx.termin_date",
      },
      statusFilter: {
        value: "",
        comparison: "yes",
        type: "list",
        field: "trx.payment_status",
      },
      summaryTempo:0,
      paymentFilter: {
        value: "payment_store",
        comparison: "=",
        type: "string",
        field: "trx_payment_method",
      },
      tempoFilter: [
        {
          value: "1",
          comparison: "=",
          type: "string",
          field: "trx.is_top",
        },
      ],
      historyStatus: null,
      isMobile: false,
    };
  },

  computed: {
    dateTempoText() {
      return this.filter.dateRangeTempo.join(" ~ ");
    },
    ...mapState("transaksiSeller", [
      "historyTrackingData",
      "pesananData",
      "pesananPagination",
      "detailPesanan",
      "response",
      "responseError",
    ]),
    dateRangeText: {
      get() {
        let dates = this.filter.dateRange
          ? new Date(this.filter.dateRange)
          : null;
        return dates ? moment(dates).format("DD MMM YYYY") : null;
      },
      set() {
        let dates = this.filter.dateRange
          ? new Date(this.filter.dateRange)
          : null;
        return dates ? moment(dates).format("DD MMM YYYY") : null;
      },
    },
  },

  async mounted() {
    this.getBankAccountList();
    // await this.getListPesanan();
    this.searchTrx();
  },
  watch: {
    lacakStatusPesanan: {
      handler: function (val) {
        // Log it
        if (val == true) {
          // console.log("detailPes:", this.detailPesanan);
          this.getDetailTracking(
            this.detailPesanan.trx_code,
            this.detailPesanan.trx_agregator,
            this.detailPesanan.order_id_kiriminaja
          );
          this.getDetailHistoryTracking(this.detailPesanan.trx_code);
        }
        // console.log("newVal", val, ("oldVal", oldVal));
      },
      deep: true,
    },
  },
  methods: {

    exportExcel() {
      this.exportLoading = true
      this.$store.dispatch("transaksiSeller/exportDataTempo", this.queryString({
          limit: this.pesananPagination.total_data,
          page: this.page,
          params: this.params,
        })).then((data) => {
          this.exportLoading = false 
        window.open(data.url, "_blank");
      });
    },
    getSummaryRemainingDebt() { 
      this.$store.dispatch("transaksiSeller/getSummaryRemainingDebt", this.queryString({
          limit: 0,
          page: 0,
          params: this.params,
        })).then((data) => { 
          this.summaryTempo = data ? data[0].total_payment_remaining_debt : 0
          console.log(data);
      }).catch(() => {
        this.summaryTempo = 0
      });
    },
    confirmTransfer(data) {
      data.append("trx_id", this.detailPesanan.trx_id);
      this.uploadCSSumbit(data).then(() => {
        this.$refs.modalPayment.modalHide();
        this.searchTrx();
      });
    },
    ...mapActions("options", ["getBankList", "getBankAccountList"]),
    uploadPayment() {
      // let bank = this.bankAccountList.find((el) => {
      //   return (
      //     el.bank_account_bank_name ==
      //       this.detailPesanan.trx_payment_data
      //         .trx_payment_bank_to_bank_account_bank_name &&
      //     el.bank_account_number ==
      //       this.detailPesanan.trx_payment_data
      //         .trx_payment_bank_to_bank_account_number
      //   );
      // });
      this.$refs.modalPayment.modalShow(
        [],
        this.detailPesanan.trx_price_total,
        this.detailPesanan.is_top
      );
    },
    previewHargaNego([item]) {
      this.dialogNego = true;
      // {
      // "trx_detail_id": "49",
      // "trx_detail_product_id": "2",
      // "trx_detail_product_name": "AMOX-AB - Amoxsan 500 Mg Kapsul",
      // // "trx_detail_price": 16850,
      // // "trx_detail_price_nego": "15000",
      // // "trx_detail_status_nego": "submitted",
      // // "trx_detail_nego_is_member": "1",
      // // "trx_detail_nego_is_seller": "0"
      // // }

      // // product_name,
      // min_price_nego,
      // cart_detail_id,
      // cart_detail_product_id,
      // cart_detail_price,
      // cart_detail_price_nego:cart_detail_price_nego,
      this.formNego = item.trx_data_nego.trx_nego_items.map((i) => {
        const {
          trx_detail_product_name: product_name,
          trx_detail_id: cart_detail_id,
          trx_detail_product_id: cart_detail_product_id,
          trx_detail_price: cart_detail_price,
          trx_detail_price_nego: cart_detail_price_nego,
        } = i;
        return {
          product_name,
          cart_detail_id,
          cart_detail_product_id,
          cart_detail_price,
          cart_detail_price_nego,
        };
      });
      console.log([item]);
    },
    ...mapActions("transaksiSeller", [
      "getHistoryTracking",
      "getTracking",
      "getTrackingKiriminaja",
      "getPesanan",
      "getPesananDetail",
      "prosesPesanan",
      "kirimPesanan",
      "pickupStore",
      "getStatusPesanan",
      "paymentStorePaid",
      "paymentStoreCancel",
      "changeResi",
      "cancelPesanan",
      "requestPickupPesanan",
      "uploadCSSumbit",
    ]),
    ...mapMutations(["makeAlert"]),
    getDetailHistoryTracking(trxCode) {
      let params = [];
      params = { trx_code: trxCode };
      this.getHistoryTracking(params)
        .then(async () => {
          this.loadingList = false;
        })
        .catch(() => {
          this.loadingList = true;
        });
    },
    async getDetailTracking(trxCode, agregator, oidKiriminaja) {
      let params = [];
      params = { trx_code: trxCode, order_id: oidKiriminaja };
      if (agregator == "kiriminaja") {
        await this.getTrackingKiriminaja(params)
          .then(async () => {
            this.loadingList = false;
          })
          .catch(() => {
            this.loadingList = true;
          });
      } else {
        await this.getTracking(params)
          .then(async () => {
            this.loadingList = false;
          })
          .catch(() => {
            this.loadingList = true;
          });
      }
    },
    async getListPesanan() {
      this.loadingList = await true;
      // let params = await [];
      let status = "";

      for (let i = 0; i < this.allowedStatus.length; i++) {
        status +=
          i < this.allowedStatus.length - 1
            ? this.allowedStatus[i] + "::"
            : this.allowedStatus[i];
      }
      this.statusFilter.value = await status;
      if (this.statusFilter.value) this.params.push(this.statusFilter);

      if (this.payment == "store") this.params.push(this.paymentFilter);
      this.params.push(...this.tempoFilter);

      this.page = await 1;
      await this.getPesanan(
        this.queryString({
          limit: this.limit,
          page: this.page,
          params: this.params,
        })
      )
        .then(async () => {
          this.listPesanan = await this.pesananData;
          this.loadingList = false;
        })
        .catch(() => {
          this.loadingList = true;
        });
    },

    filterAllowedStatus(data) {
      let showList = data.filter((d) =>
        this.allowedStatus.includes(d.trx_status)
      );
      return showList;
    },

    statusCaption(status) {
      if (status === "paid") return "Tagihan Lunas";
      else if (status === "pending") return "Tagihan Belum Dibayarkan";
      else if (!status) return "Tagihan Belum Dibayarkan";
      else if (status === "partial") return "Tagihan Dibayarkan Partial";
    },

    colorStatus(status) {
      if (status === "paid") return "green white--text";
      else if (status === "partial") return "blue darken-1 white--text";
      else if (!status) return "orange darken-1 white--text";
      else if (status === "pending" || !status)
        return "orange darken-1 white--text";
    },

    async openReminderDialog(item) {
      this.selectedItem = await item;
      this.dialogReminderStock = true;
    },

    formatDateText(params, format) {
      let dates = params ? new Date(params) : null;
      return dates ? moment(dates).format(format) : null;
    },

    async clearDate() {
      this.filter.dateRange = await null;
      this.tglTransaksiFilter.value = await this.filter.dateRange;
      this.filter.dateRangeTempo = await [];
      this.tglTransaksiTempoFilter.value = await '';
      this.searchTrx();
    },

    async loadDetailPesanan({ item }) {
      this.loadingDetail = await true;
      const params = await {
        id: item.trx_id,
      };
      await this.getPesananDetail(params).then(() => {
        this.allowChangeResi = false;
        this.courier_note = this.detailPesanan.trx_courier_note;
        this.courier_resi = this.detailPesanan.trx_courier_resi;
        this.pickup_date = this.detailPesanan.trx_pick_up_date;

        const histories = [
          {
            trx_status: "created",
            trx_status_datetime: this.detailPesanan.trx_status_created_datetime,
            trx_status_desc:
              "Pembeli membuat pemesanan baru dari Toko Anda. Menunggu pembayaran dari pembeli.",
          },
          {
            trx_status: "paid",
            trx_status_datetime: this.detailPesanan.trx_status_paid_datetime,
            trx_status_desc:
              "Pembayaran oleh pembeli Berhasil. Pemesanan Barang akan diteruskan ke Penjual.",
          },
          {
            trx_status: "processed",
            trx_status_datetime:
              this.detailPesanan.trx_status_processed_datetime,
            trx_status_desc:
              "Pesanan sudah diterima Penjual dan diproses ke Pengiriman.",
          },
          {
            trx_status: "pickup",
            trx_status_datetime: this.detailPesanan.trx_status_pickup_datetime,
            trx_status_desc: "Permintaan pickup/drop off sudah dilakukan.",
          },
          {
            trx_status: "on_delivery",
            trx_status_datetime:
              this.detailPesanan.trx_status_on_delivery_datetime,
            trx_status_desc:
              "Pesanan telah dikirimkan dengan nomor resi " +
              this.courier_resi +
              " .",
          },
          {
            trx_status: "completed",
            trx_status_datetime:
              this.detailPesanan.trx_status_completed_datetime,
            trx_status_desc:
              "Pemesanan telah selesai dan diterima oleh Pembeli.",
          },
          {
            trx_status: "cancel",
            trx_status_datetime: this.detailPesanan.trx_status_cancel_datetime,
            trx_status_desc: "Pemesanan Anda telah dibatalkan.",
          },
          {
            trx_status: "rejected_admin",
            trx_status_datetime:
              this.detailPesanan.trx_status_rejected_admin_datetime,
            trx_status_desc: "Pemesanan Anda tidak disetujui oleh Admin.",
          },
        ];
        const sortedActivities = histories.sort((a, b) => {
          if (a.trx_status_datetime > b.trx_status_datetime) return -1;
          if (a.trx_status_datetime < b.trx_status_datetime) return 1;
          return 0;
        });
        this.historyStatus = sortedActivities;
      });
      this.loadingDetail = false;
    },

    setSlugProduct(id, nama) {
      return id + "-" + nama.toLowerCase().replace(/ /g, "-");
    },

    async searchTrx() {
      this.loadingList = await true;
      this.params = [];
      if (this.filter.type.value === "buyer") {
        if (this.buyerNameFilter.value)
          await this.params.push(this.buyerNameFilter);
      } else if (this.filter.type.value === "invoice") {
        if (this.invoiceNoFilter.value)
          await this.params.push(this.invoiceNoFilter);
      } else {
        if (this.invoiceTrxFilter.value)
          await this.params.push(this.invoiceTrxFilter);
      }
      if (this.tglTransaksiFilter.value)
        await this.params.push(this.tglTransaksiFilter);

      if (this.allowedStatus.length === 1)
        this.statusFilter.value = await this.allowedStatus;
      if (this.statusFilter.value) await this.params.push(this.statusFilter);

      if (this.filter.dateRangeTempo.length > 0) {
        if (this.filter.dateRangeTempo.length == 1) {
          this.tglTransaksiTempoFilter.value = this.createFilterDate(
            this.filter.dateRangeTempo[0],
            this.filter.dateRangeTempo[0]
          );
        } else if (this.filter.dateRangeTempo.length == 2) {
          this.tglTransaksiTempoFilter.value = this.createFilterDate(
            this.filter.dateRangeTempo[0],
            this.filter.dateRangeTempo[1]
          );
        }
      }
      if (this.tglTransaksiTempoFilter.value !== "") {
        this.params.push(this.tglTransaksiTempoFilter);
      }
      this.params.push(...this.tempoFilter);
      this.page = await 1;
      await this.getPesanan(
        this.queryString({
          limit: this.limit,
          page: this.page,
          params: this.params,
        })
      )
        .then(async () => {
          this.listPesanan = await this.pesananData;
          this.loadingList = false;
        })
        .catch(() => {
          this.loadingList = false;
        }); 
      this.getSummaryRemainingDebt()
    },

    createFilterDate(date1, date2) {
      return (
        moment(date1).format("YYYY-MM-DD") +
        "::" +
        moment(date2).format("YYYY-MM-DD")
      );
    },
    async clearSearch() {
      this.filter.search = await "";
      this.filter.type = await {
        label: "No. Invoice",
        value: "invoice",
      };
      this.buyerNameFilter.value = await "";
      this.invoiceNoFilter.value = await "";
      this.searchTrx();
    },

    async updatePage(val) {
      // this.loadingList = await true;
      // let params = await [];
      // let status = "";

      // for (let i = 0; i < this.allowedStatus.length; i++) {
      //   status +=
      //     i < this.allowedStatus.length - 1
      //       ? this.allowedStatus[i] + "::"
      //       : this.allowedStatus[i];
      // }
      // this.statusFilter.value = await status;
      // if (this.statusFilter.value) params.push(this.statusFilter);

      // await this.getPesanan(
      //   this.queryString({ limit: 5, page: val, params: params })
      // )
      //   .then(async () => {
      //     this.listPesanan = await this.pesananData;
      //     this.loadingList = false;
      //   })
      //   .catch(() => {
      //     this.loadingList = false;
      //   });
      this.page = val;
      this.getPesanan(
        this.queryString({
          limit: this.limit,
          page: this.page,
          params: this.params,
          sort: this.sortBy,
          dir: this.sortDir,
        })
      )
        .then(async () => {
          this.listPesanan = await this.pesananData;
          this.loadingList = false;
        })
        .catch(() => {
          this.loadingList = false;
        });
    },

    async openConfirmProses(item) {
      this.selectedItem = await item;
      this.dialogConfirmTerimaorder = true;
      // this.clearSearch();
      this.getListPesanan();
    },

    async openConfirmKirim(item) {
      if (this.$refs.formKirimPesanan.validate()) {
        this.selectedItem = await item;
        this.dialogConfirmKirim = true;
        this.getListPesanan();
      }
    },

    async openConfirmRequestPickup(item, is_drop = 0) {
      if (this.$refs.formKirimPesanan.validate()) {
        this.selectedItem = await item;
        this.selectedItem.is_drop = await is_drop;
        this.dialogConfirmRequestPickup = true;
        this.getListPesanan();
      }
    },

    async openConfirmChangeResi(item) {
      if (this.$refs.formChangeResi.validate()) {
        this.selectedItem = await item;
        this.dialogConfirmTerimaorder = true;
        this.getListPesanan();
      }
    },

    async prosesPesananAct(id) {
      this.loadingStatus = await true;
      const params = await {
        trx_id: id,
      };
      // alert("tes");
      // return;
      await this.prosesPesanan(params)
        .then(async () => {
          await this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true,
          });

          this.selectedItem = await null;
          this.dialogConfirmTerimaorder = await false;
          this.loadingStatus = await false;
          await this.getListPesanan();
          await this.getStatusPesanan();
          await location.reload();
        })
        .catch(() => {
          this.selectedItem = null;
          this.dialogConfirmTerimaorder = false;
          this.loadingStatus = false;
          this.getListPesanan();
          this.getStatusPesanan();
        });
    },

    async ubahResi(id) {
      this.loadingStatus = await true;
      const params = await {
        trx_id: id,
        trx_courier_resi: this.courier_resi,
      };

      await this.changeResi(params)
        .then(async () => {
          await this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true,
          });
          await this.getListPesanan();
          await this.getStatusPesanan();
          await this.loadDetailPesanan({
            item: params,
          });
          this.selectedItem = await null;
          this.dialogConfirmTerimaorder = await false;
          this.loadingStatus = false;
          this.allowChangeResi = false;
        })
        .catch(() => {
          this.selectedItem = null;
          this.dialogConfirmTerimaorder = false;
          this.loadingStatus = false;
        });
    },

    async requestPickupPesananAct(id, is_drop = 0) {
      this.loadingStatus = await true;
      const params = await {
        trx_id: id,
        trx_courier_note: this.courier_note,
        is_drop: is_drop,
      };

      await this.requestPickupPesanan(params)
        .then(async () => {
          await this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true,
          });
          await this.loadDetailPesanan({
            item: params,
          });
          await this.getListPesanan();
          await this.getStatusPesanan();
          this.selectedItem = await null;
          this.dialogConfirmRequestPickup = await false;
          this.loadingStatus = false;
        })
        .catch(() => {
          this.selectedItem = null;
          this.dialogConfirmRequestPickup = false;
          this.loadingStatus = false;
        });
    },

    async kirimPesananAct(id) {
      this.loadingStatus = await true;
      const params = await {
        trx_id: id,
        trx_courier_resi: this.courier_resi,
        trx_courier_note: this.courier_note,
      };

      await this.kirimPesanan(params)
        .then(async () => {
          await this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true,
          });
          await this.loadDetailPesanan({
            item: params,
          });
          await this.getListPesanan();
          await this.getStatusPesanan();
          this.selectedItem = await null;
          this.dialogConfirmKirim = await false;
          this.loadingStatus = false;
        })
        .catch(() => {
          this.selectedItem = null;
          this.dialogConfirmKirim = false;
          this.loadingStatus = false;
        });
    },

    async pengambilanPesananAct(id, date) {
      this.loadingStatus = await true;
      const params = await {
        trx_id: id,
        pick_up_date: date,
        trx_courier_note: this.courier_note,
      };

      await this.pickupStore(params)
        .then(async () => {
          await this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true,
          });
          await this.loadDetailPesanan({
            item: params,
          });
          await this.getListPesanan();
          await this.getStatusPesanan();
          this.selectedItem = await null;
          this.dialogConfirmKirim = await false;
          this.loadingStatus = false;
        })
        .catch(() => {
          this.selectedItem = null;
          this.dialogConfirmKirim = false;
          this.loadingStatus = false;
        });
    },

    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },

    printInvoice(id) {
      let routeData = this.$router.resolve({ path: "/seller/invoice/" + id });
      window.open(routeData.href, "_blank");
    },
    printShipping(id) {
      let routeData = this.$router.resolve({
        path: "/seller/shipping-label/" + id,
      });
      window.open(routeData.href, "_blank");
    },
    confirmPayment(data) {
      this.paymentStorePaid({
        trx_id: data.trx_id,
      })
        .then(async () => {
          await this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true,
          });
          await this.getListPesanan();
          await this.getStatusPesanan();
          this.loadingStatus = false;
        })
        .catch(() => {
          this.loadingStatus = false;
        });
    },
    cancelTransaction(data) {
      this.paymentStoreCancel({
        trx_id: data.trx_id,
      })
        .then(async () => {
          await this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true,
          });
          await this.getListPesanan();
          await this.getStatusPesanan();
          this.loadingStatus = false;
        })
        .catch(() => {
          this.loadingStatus = false;
        });
    },
    cancelTransactionV2(data) {
      this.cancelPesanan({
        trx_id: data.trx_id,
      })
        .then(async () => {
          await this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true,
          });
          await this.getListPesanan();
          await this.getStatusPesanan();
          this.loadingStatus = false;
        })
        .catch(() => {
          this.loadingStatus = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.v-spacer {
  width: 1px;
  height: 30px;
  background: transparent;
  display: block;
  position: relative;
  margin: 0 auto;
  border-left: 3px dotted #ccc;
}
</style>
